import { ApolloError } from '@apollo/client';
import { CloseRodRequestErrorCode } from '@bechtel/types';

export type CloseRodRequestErrorType = CloseRodRequestErrorCode | ApolloError;

export interface CloseRodRequestErrorProps {
  error: CloseRodRequestErrorType;
  close: () => void;
}
